import { useState, useEffect, useCallback, useRef } from 'react';
import useAppStore from 'store/store';

const useFocus = () => {

	const setIsFocused = useAppStore((state) => state.setIsFocused);

    const handleVisibilityChange = useCallback(() => {
        setIsFocused( document.visibilityState === 'visible' );
    }, []);

    const handleOnBlur = useCallback(() => {
        setIsFocused( false );
    }, []);

    const handleOnFocus = useCallback(() => {
        setIsFocused( true );
    }, []);

    useEffect(() => {

        window.addEventListener( "blur", handleOnBlur );
        window.addEventListener( "focus", handleOnFocus );

        document.addEventListener( "visibilitychange", handleVisibilityChange )

        return () => {
            window.removeEventListener( "blur", handleOnBlur );
            window.removeEventListener( "focus", handleOnFocus );

            document.removeEventListener( "visibilitychange", handleVisibilityChange );
        };
    }, []);

    return null
}

export default useFocus;